import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import { ICompanyBase } from '@/types'
import { getFormattedAmount, getShortText } from '@/utils'
import { IconTextItem } from '@components-v2/atoms/IconTextItem'
import TargetSvg from '@/public/images/common/target-01_v2.svg'
import TrendUpSvg from '@/public/images/common/trend-up-01_v2.svg'
import BankNoeSvg from '@/public/images/common/bank-note-01_v2.svg'
import PinSvg from '@/public/images/common/marker-pin-01_v2.svg'
import styles from './index.module.scss'

type Props = {
  company: ICompanyBase
}

export const StartUpCardContent: FC<Props> = ({ company }) => {
  const { t } = useTranslation(['p'])

  const markets = company?.markets.map((m) => m.name)
  if (markets.length === 0) {
    markets.push(t('未設定'))
  }
  const rounds = []
  if (company?.round?.name) {
    rounds.push(company.round.name)
  }
  const locations = company?.locations.map((l) => l.name)
  if (locations.length === 0) {
    locations.push(t('未設定'))
  }

  const currency = company?.currencyUnit
  const amount = getFormattedAmount(Number(company?.totalFundingAmount), currency) || ''

  return (
    <div className={styles.container}>
      <div className={styles.name}>{company.name}</div>
      <div className={styles.conceptPitch}>{company.conceptPitch}</div>
      <div className={styles.aboutUs}>
        <p>{getShortText(company.aboutUs, 140)}</p>
      </div>
      <div className={styles.footer}>
        <IconTextItem icon={<TargetSvg viewBox='0 0 24 24' />} nameList={markets} />
        <IconTextItem icon={<TrendUpSvg viewBox='0 0 24 24' />} nameList={rounds} />
        <IconTextItem icon={<BankNoeSvg viewBox='0 0 24 24' />} nameList={[amount]} />
        <IconTextItem icon={<PinSvg viewBox='0 0 24 24' />} nameList={locations} />
      </div>
    </div>
  )
}
